export default () => ({
  root: {
    position: 'absolute',
    right: '0',
    marginRight: '0',
    top: '0',
    padding: '12px',
  },
});
